import i18n from 'services/base/i18n';

export default {
  // Title text on the setup your pangolin page
  title: () => i18n.pgettext('Pages|Add Pangolin|Setup', 'Setup your Pangolin'),

  // Instructions on how to setup the pangolin device
  instructions: () => i18n.pgettext(
    'Pages|Add Pangolin|Setup',
    'Connect Pangolin WAN port to ISP modem / router Lan 1 Port using the supplied cat6 cable.',
  ),

  // Text for the link to continue to the next page
  next: () => i18n.pgettext('Pages|Add Pangolin|Setup', 'NEXT'),

  // Text for the user to log out if they don't have a Pangolin
  logout: () => i18n.pgettext('Pages|Add Pangolin|Setup', 'LOG OUT'),
};
